import { DuplicatePatientCheckResult } from "./duplicate-patient";

export enum ResultErrorType {
    None = 1,
    Validation,
    Im1,
    LinkNhsMipro,
    IsUser,
    LinkIM1Failed,
    Unknown
}

export enum ResultType {
    None = 1,
    Duplicates,
    LinkedToOrganization,
    LoggedIn
}

export interface CreateSelfRegisterResult {
    success: boolean;
    errorType?: ResultErrorType;
    errorMessage?: string;
    resultType?: ResultType;
    duplicates?: DuplicatePatientCheckResult;
    patientId?: string;
}
